/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Operations_Val_QtyInputs */

const en_wb_operations_val_qty = /** @type {(inputs: Wb_Operations_Val_QtyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`120`)
};

const lv_wb_operations_val_qty = /** @type {(inputs: Wb_Operations_Val_QtyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`120`)
};

/**
* | output |
* | --- |
* | "120" |
*
* @param {Wb_Operations_Val_QtyInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_operations_val_qty = /** @type {((inputs?: Wb_Operations_Val_QtyInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Operations_Val_QtyInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_operations_val_qty(inputs)
	return en_wb_operations_val_qty(inputs)
});